// extracted by mini-css-extract-plugin
export default {"numberInput":"OrderAhead_numberInput__v6fkA","futureFaysLimit":"OrderAhead_futureFaysLimit__bAlc3"};